const CHGMEMODATA = 'chgMemoData'
const REGSCREEN = 'registerScreen'
const INPUTIRSPOS = 'inputIrsPos'


export {CHGMEMODATA,REGSCREEN, INPUTIRSPOS}